export const viewOrder = {
  "depotfinder.decision": 1,
  "depotfinder.age": 2,
  "depotfinder.orders": 3,
  "depotfinder.assets": 4,
  "depotfinder.services": 5,
  "depotfinder.results": 6
};
